const data = [
    {
        filterBy: 'Dish Type',
        filterList: ['Appetizers & Snacks', 'Cake Recipes', 'Candy and Fudge', 'Casserole Recipes', 'Cocktail Recipes',
            'Main Dishes', 'Pasta Recipes', 'Pie Recipes ', 'Sandwiches'
        ],
        open: false,
    }
    ,
    {
        filterBy: 'Meal Type',
        filterList: ['Breakfast and Brunch', 'Desserts', 'Dinners', 'Lunchs',
        ],
        open: false,
    }
    ,
    {
        filterBy: 'Diet and Health',
        filterList: ['Diabetic', 'Gluten Free', 'High Fiber Recipes', 'Low Calorie',
        ],
        open: false,
    }
    ,
    {
        filterBy: ' World Cuisine',
        filterList: ['Chinese', 'Indian', 'Italian', 'Mexican',
        ],
        open: false,
    }
    ,
    {
        filterBy: ' Seasonal',
        filterList: ['Baby Shower', 'Birthday', 'El Fetr Feast', 'El Adha Feast',
        ],
    }
];
export default data;
